namespace SSi.Blazor.Common.Shared.IdbStorage {

    class SSiIdbStorage {
        public idbDatabase: any;

        open(dbName, dbVersion, data) {
            if (this.idbDatabase)
                return Promise.resolve();

            return new Promise((resolve, reject) => {
                const dbOpenDBRequest = window.indexedDB.open(dbName, dbVersion);
                dbOpenDBRequest.onerror = (event) => reject(event);
                dbOpenDBRequest.onsuccess = () => {
                    this.idbDatabase = dbOpenDBRequest.result;
                    resolve(dbOpenDBRequest.result);
                };
                dbOpenDBRequest.onupgradeneeded = () => this.handleOnUpgradeNeeded(dbOpenDBRequest.result, dbOpenDBRequest.transaction, data);
            });
        }

        handleOnUpgradeNeeded(idbDatabaseX, idbTransactionX, dataX) {
            const handleOnUpgradeNeededEvent = new CustomEvent('SSiIdbStorage.handleOnUpgradeNeeded', { detail: { idbDatabaseX, dataX } });
            window.dispatchEvent(handleOnUpgradeNeededEvent);

            for (const storeData of dataX) {
                if (idbDatabaseX.objectStoreNames.contains(storeData.name)) {
                    // store exists upgrade is by adding missing indexes
                    const transaction = idbTransactionX;
                    transaction.onerror = e => { console.log("handleOnUpgradeNeeded Error: " + e.target.error.message); }
                    transaction.oncomplete = _ => { console.log("handleOnUpgradeNeeded Complete"); }
                    if (!storeData.indices) {
                        continue;
                    }
                    const store = transaction.objectStore(storeData.name);
                    this.updateIndecies(store, storeData);
                    transaction.commit();
                } else {
                    // if not exists create the store
                    const store = idbDatabaseX.createIdbStore(storeData.name, storeData.options);
                    if (!storeData.indices) {
                        continue;
                    }
                    this.updateIndecies(store, storeData);
                }
            }
        }

        updateIndecies(store, storeData) {
            for (const index of storeData.indices) {
                if (store.indexNames.contains(index.name)) {
                    console.log(storeData.name + " Skipping existing index named: " + index.name);
                } else {
                    console.log(storeData.name + " Creating index named: " + index.name);
                    store.createIndex(index.name, index.name, index.options);
                }
            }
        }


        executeWithTransaction(storeName, action) {
            return new Promise((resolve, reject) => {
                const transaction = this.idbDatabase.transaction(storeName, "readwrite");
                transaction.onerror = e => { reject(e.target.error.message); }
                transaction.oncomplete = _ => { resolve(true); }

                const store = transaction.objectStore(storeName);
                action(store, transaction);
            });
        }

        add(storeName, model) {
            return new Promise((resolve, reject) => {
                const transaction = this.idbDatabase.transaction(storeName, "readwrite");
                const store = transaction.objectStore(storeName);

                delete model.key;
                const request = store.add(model);
                transaction.onerror = e => { reject(e.target.error.message); }
                transaction.oncomplete = _ => {
                    resolve(request.result);
                };
            });
        }

        put(storeName, model) {
            return this.executeWithTransaction(storeName, (store, transaction) => {
                store.put(model, model.key);
            });
        }

        get(storeName, key) {
            return new Promise((resolve, reject) => {
                const transaction = this.idbDatabase.transaction(storeName, "readonly");
                const store = transaction.objectStore(storeName);

                var request = store.get(key);
                request.onerror = (e) => { reject(e.target.error.message); }
                request.onsuccess = (e) => {
                    const model = e.target.result;
                    model.key = key;
                    resolve(model);
                }
            });
        }

        delete(storeName, key) {
            return this.executeWithTransaction(storeName, (store, transaction) => {
                store.delete(key);
            });
        }

        getAll(storeName) {
            return new Promise((resolve, reject) => {
                const transaction = this.idbDatabase.transaction(storeName, "readonly");
                const store = transaction.objectStore(storeName);
                var request = store.getAll();
                request.onerror = (e) => { reject(e.target.error.message); }
                request.onsuccess = (e) => resolve(e.target.result);
            });
        }

        openCursor(storeName) {
            return new Promise((resolve, reject) => {
                const transaction = this.idbDatabase.transaction(storeName, "readonly");
                const store = transaction.objectStore(storeName);

                var results = [];
                var cursor = store.openCursor();
                cursor.onerror = (e) => reject(e.target.error.message);
                cursor.onsuccess = function (event) {
                    cursor = event.target.result;
                    if (cursor) {
                        const model = cursor.value;
                        model.key = cursor.key;
                        results.push(model);
                        cursor.continue();
                    } else {
                        resolve(results);
                    }
                };
            });
        }
    }

    (window as any).SSiIdbStorageInstance = new SSiIdbStorage();
}
